// src/App.js
import React, { useState, useEffect, useCallback } from 'react';
import './App.css';

// IMPORTANTE: Substitua pela URL do seu Worker quando fizer o deploy
const API_BASE_URL = 'https://cloaking-engine.fazendinhacontingencia.workers.dev'; 

function App( ) {
    const [campaigns, setCampaigns] = useState([]);
    const [logs, setLogs] = useState([]);
    const [form, setForm] = useState({ domain: '', money_page_url: '', score_threshold: 40, is_active: true, rule_asn_enabled: true, rule_user_agent_enabled: true, rule_header_analysis_enabled: true, rule_mouse_movement_enabled: true });
    const [editingId, setEditingId] = useState(null);
    const [view, setView] = useState('campaigns'); // 'campaigns' ou 'logs'

    const fetchCampaigns = useCallback(async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/campaigns`);
            if (!response.ok) throw new Error('Failed to fetch campaigns');
            const data = await response.json();
            setCampaigns(data);
        } catch (error) {
            console.error(error);
            alert(error.message);
        }
    }, []);

    const fetchLogs = useCallback(async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/logs`);
            if (!response.ok) throw new Error('Failed to fetch logs');
            const data = await response.json();
            setLogs(data);
        } catch (error) {
            console.error(error);
            alert(error.message);
        }
    }, []);

    useEffect(() => {
        if (view === 'campaigns') {
            fetchCampaigns();
        } else {
            fetchLogs();
        }
    }, [view, fetchCampaigns, fetchLogs]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const url = editingId ? `${API_BASE_URL}/api/campaigns/${editingId}` : `${API_BASE_URL}/api/campaigns`;
        const method = editingId ? 'PUT' : 'POST';

        try {
            const response = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...form, score_threshold: parseInt(form.score_threshold) })
            });
            if (!response.ok) {
                const err = await response.json();
                throw new Error(err.error || 'Failed to save campaign');
            }
            resetForm();
            fetchCampaigns();
        } catch (error) {
            console.error(error);
            alert(error.message);
        }
    };

    const handleEdit = (campaign) => {
        setEditingId(campaign.id);
        setForm({ ...campaign, is_active: !!campaign.is_active, rule_asn_enabled: !!campaign.rule_asn_enabled, rule_user_agent_enabled: !!campaign.rule_user_agent_enabled, rule_header_analysis_enabled: !!campaign.rule_header_analysis_enabled, rule_mouse_movement_enabled: !!campaign.rule_mouse_movement_enabled });
    };

    const handleDelete = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar esta campanha?')) {
            try {
                const response = await fetch(`${API_BASE_URL}/api/campaigns/${id}`, { method: 'DELETE' });
                if (!response.ok) throw new Error('Failed to delete campaign');
                fetchCampaigns();
            } catch (error) {
                console.error(error);
                alert(error.message);
            }
        }
    };

    const resetForm = () => {
        setEditingId(null);
        setForm({ domain: '', money_page_url: '', score_threshold: 40, is_active: true, rule_asn_enabled: true, rule_user_agent_enabled: true, rule_header_analysis_enabled: true, rule_mouse_movement_enabled: true });
    };

    return (
        <div className="App">
            <nav>
                <button onClick={() => setView('campaigns')} className={view === 'campaigns' ? 'active' : ''}>Campanhas</button>
                <button onClick={() => setView('logs')} className={view === 'logs' ? 'active' : ''}>Logs</button>
            </nav>
            <main>
                {view === 'campaigns' && (
                    <div>
                        <h1>Gerenciar Campanhas</h1>
                        <form onSubmit={handleSubmit} className="campaign-form">
                            <input name="domain" value={form.domain} onChange={handleInputChange} placeholder="Domínio (ex: meudominio.com)" required />
                            <input name="money_page_url" value={form.money_page_url} onChange={handleInputChange} placeholder="URL da Money Page" required />
                            <input name="score_threshold" type="number" value={form.score_threshold} onChange={handleInputChange} placeholder="Bot Score Threshold" required />
                            <fieldset>
                                <legend>Regras de Cloaking</legend>
                                <label><input type="checkbox" name="rule_asn_enabled" checked={form.rule_asn_enabled} onChange={handleInputChange} /> Bloqueio por ASN</label>
                                <label><input type="checkbox" name="rule_user_agent_enabled" checked={form.rule_user_agent_enabled} onChange={handleInputChange} /> Análise de User-Agent</label>
                                <label><input type="checkbox" name="rule_header_analysis_enabled" checked={form.rule_header_analysis_enabled} onChange={handleInputChange} /> Análise de Headers</label>
                                <label><input type="checkbox" name="rule_mouse_movement_enabled" checked={form.rule_mouse_movement_enabled} onChange={handleInputChange} /> Verificação de Mouse</label>
                            </fieldset>
                            <button type="submit">{editingId ? 'Atualizar' : 'Criar'}</button>
                            {editingId && <button type="button" onClick={resetForm}>Cancelar Edição</button>}
                        </form>
                        <div className="campaign-list">
                            {campaigns.map(c => (
                                <div key={c.id} className="campaign-item">
                                    <span>{c.domain} &rarr; {c.money_page_url} (Score: {c.score_threshold})</span>
                                    <div>
                                        <button onClick={() => handleEdit(c)}>Editar</button>
                                        <button onClick={() => handleDelete(c.id)}>Deletar</button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {view === 'logs' && (
                    <div>
                        <h1>Logs de Acesso</h1>
                        <table className="logs-table">
                            <thead>
                                <tr>
                                    <th>Data</th>
                                    <th>URL</th>
                                    <th>Decisão</th>
                                    <th>Score</th>
                                    <th>IP</th>
                                    <th>País</th>
                                    <th>ASN</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.map(log => (
                                    <tr key={log.id}>
                                        <td>{new Date(log.timestamp).toLocaleString()}</td>
                                        <td>{log.incoming_url}</td>
                                        <td>{log.decision}</td>
                                        <td>{log.bot_score}</td>
                                        <td>{log.ip_address}</td>
                                        <td>{log.country}</td>
                                        <td>{log.asn_organization}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </main>
        </div>
    );
}

export default App;
